export const MATCHER_PHONE_VALIDATION_REGEX =
  /^\(?(?!37|96|900|456|555)[2-9](?!11)[0-8]\d\)?[-.\s]?(?!555[-.\s]?(?:1212|01)|(\d)\1{2}[-.\s]?\1{4})[2-9](?!11)\d{2}[-.\s]?\d{4}$/;
